module.exports = __webpack_public_path__ + "img/btn-right.836f3044.svg";